import React from 'react';

function WhyDefiSection() {
  return (
    <div>
      <p>
        DeFi offers decentralized finance without intermediaries, giving you
        control over your assets. Unlike CEX, where funds are held by exchanges,
        DeFi promotes self-custody and transparency.
      </p>
      <p>
        Learn more about alternatives:{' '}
        <a href="/alternatives">Explore DeFi Options</a>
      </p>
    </div>
  );
}

export default WhyDefiSection;
